import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Col, Row, Card, CardBody, Button } from 'reactstrap';
import { Field, reduxForm, FieldArray } from 'redux-form'
import DropDownSelect from '../Dropdown/index';
import {PAYMENT_RISK_GRADE_DEFAULT_ROW} from '../constants';
// import { checkSubmitError, checkZeroValue, checkOne } from '../helper';

const renderMembers = ({ fields, riskLevels, meta: { error, submitFailed } }) => (
    < ul >
        {fields.map((member, index) => (
            <li key={index}>
                <Row className="d-flex align-items-center mb-3">
                    <Col sm="4" className="px-2">
                        <div className="d-flex align-items-center text-secondary border radius-5 p-2">
                            <Field
                                type="number"
                                name={`${member}.minScore`}
                                component="input"
                                className="w-45 border-0 radius-5 risk-grade-input"
                                placeholder="min" />
                            <span className="d-inline-block mr-2 border-right">&nbsp;</span>
                            <Field type="number"
                                component="input"
                                className="w-45 border-0 radius-5 risk-grade-input"
                                placeholder="max"
                                name={`${member}.maxScore`} />
                        </div>
                    </Col>
                    <Col sm="4" className="px-2">
                        <div>
                            <Field
                                component="input"
                                name={`${member}.riskGrade`}
                                type="text"
                                placeholder="Grades"
                                className="p-2 w-100 radius-5 border risk-grade-input" />
                        </div>
                    </Col>
                    <Col sm="4" className="px-2">
                        <div className="border dropdown-counterparty riskgrade-category-dd">
                            <Field
                                name={`${member}.riskLevel`}
                                type="text"
                                component={DropDownSelect}
                                label="State"
                                data={riskLevels}
                            >

                            </Field>
                        </div>
                    </Col>
                    <Col sm="7" className="px-2">
                        <div className="">
                            <Field type="text"
                                name={`${member}.gradeDescription`}
                                component="input"
                                placeholder="Grade Description"
                                className="p-2 w-100 radius-5 border risk-grade-input" />
                        </div>
                    </Col>
                    <Col sm="3" className="px-2">
                        <div className="">
                            <Field type="number"
                                name={`${member}.pd`}
                                component="input"
                                placeholder="00"
                                className="p-2 w-100 radius-5 border risk-grade-input" />
                        </div>
                    </Col>
                    <Col sm="2" className="px-2 text-right"><a onClick={() => fields.remove(index)}><i className="icon-close text-danger pointer"></i></a> </Col>
                </Row>
            </li>
        ))}
        < Row >
            <Button type="button" className="d-flex ml-auto text-primary text-decoration-none pr-0" color="link" onClick={() => fields.push(PAYMENT_RISK_GRADE_DEFAULT_ROW)}><i className="icon-plus mr-2 text-decoration-none"></i>Add More</Button>
        </Row >

    </ul >
)



class PaymentRiskGradeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    componentDidMount() {
        this.props.initialize({
            riskGrades: [{
                minScore: '',
                maxScore: '',
                riskGrade: '',
                riskLevel: '',
                gradeDescription: '',
                pd: ''
            }]
        })
    }
    componentDidUpdate(prevProps) {
        if (this.props.initialData !== prevProps.initialData) {
            this.props.initialize({
                riskGrades: this.props.initialData
            })
        }
    }
    render() {
        const { error } = this.props
        return (
            <form>
                <Card className="shadow-none">
                    <CardBody>
                        <Row className="mb-1">
                            <Col sm="4" className="px-2">Range</Col>
                            <Col sm="4" className="px-2">Grades</Col>
                            <Col sm="4" className="px-2">Category</Col>
                            <Col sm="7" className="px-2">Grade Description</Col>
                            <Col sm="3" className="px-2">PD</Col>
                            <Col sm="2" className="px-2"></Col>
                        </Row>
                        <FieldArray name="riskGrades" component={renderMembers} riskLevels={this.props.riskLevels} />
                        {/* <FieldArray name="members" fields={this.state.riskGradeBody} component={renderMembers} riskLevels={this.props.riskLevels}/> */}

                    </CardBody>

                </Card>

                <strong className='text-danger mb-5'>{error ? error : ""}</strong>
            </form>
        )
    }
}


const mapStateToProps = (state, ownProps) => ({
    // editdata: state.corporateOnBoardingCreate.editData
    aggregateFormData: state.form.AggregateFieldsForm

})

const mapDispatchToProps = (dispatch, ownProps) => ({
})

export default reduxForm({
    form: 'PaymentRiskGradeForm'
})(connect(mapStateToProps, mapDispatchToProps)(PaymentRiskGradeForm))
